// src/utils/countryTimezones.js

const COUNTRY_TIMEZONES = {
  Afghanistan: "Asia/Kabul",
  Albania: "Europe/Tirane",
  Algeria: "Africa/Algiers",
  Andorra: "Europe/Andorra",
  Angola: "Africa/Luanda",
  Argentina: "America/Argentina/Buenos_Aires",
  Armenia: "Asia/Yerevan",
  Australia: "Australia/Sydney",
  Austria: "Europe/Vienna",
  Azerbaijan: "Asia/Baku",

  Bahamas: "America/Nassau",
  Bahrain: "Asia/Bahrain",
  Bangladesh: "Asia/Dhaka",
  Barbados: "America/Barbados",
  Belarus: "Europe/Minsk",
  Belgium: "Europe/Brussels",
  Belize: "America/Belize",
  Benin: "Africa/Porto-Novo",
  Bhutan: "Asia/Thimphu",
  Bolivia: "America/La_Paz",
  "Bosnia and Herzegovina": "Europe/Sarajevo",
  Botswana: "Africa/Gaborone",
  Brazil: "America/Sao_Paulo",
  Brunei: "Asia/Brunei",
  Bulgaria: "Europe/Sofia",
  BurkinaFaso: "Africa/Ouagadougou",
  Burundi: "Africa/Bujumbura",

  Cambodia: "Asia/Phnom_Penh",
  Cameroon: "Africa/Douala",
  Canada: "America/Toronto",
  Chad: "Africa/Ndjamena",
  Chile: "America/Santiago",
  China: "Asia/Shanghai",
  Colombia: "America/Bogota",
  Congo: "Africa/Brazzaville",
  CostaRica: "America/Costa_Rica",
  Croatia: "Europe/Zagreb",
  Cuba: "America/Havana",
  Cyprus: "Asia/Nicosia",
  "Czech Republic": "Europe/Prague",

  Denmark: "Europe/Copenhagen",
  Djibouti: "Africa/Djibouti",
  Dominica: "America/Dominica",
  DominicanRepublic: "America/Santo_Domingo",

  Ecuador: "America/Guayaquil",
  Egypt: "Africa/Cairo",
  ElSalvador: "America/El_Salvador",
  England: "Europe/London",
  Estonia: "Europe/Tallinn",
  Ethiopia: "Africa/Addis_Ababa",

  Fiji: "Pacific/Fiji",
  Finland: "Europe/Helsinki",
  France: "Europe/Paris",

  Gabon: "Africa/Libreville",
  Gambia: "Africa/Banjul",
  Georgia: "Asia/Tbilisi",
  Germany: "Europe/Berlin",
  Ghana: "Africa/Accra",
  Greece: "Europe/Athens",
  Greenland: "America/Godthab",
  Guatemala: "America/Guatemala",
  Guinea: "Africa/Conakry",

  Haiti: "America/Port-au-Prince",
  Honduras: "America/Tegucigalpa",
  HongKong: "Asia/Hong_Kong",
  Hungary: "Europe/Budapest",

  Iceland: "Atlantic/Reykjavik",
  India: "Asia/Kolkata",
  Indonesia: "Asia/Jakarta",
  Iran: "Asia/Tehran",
  Iraq: "Asia/Baghdad",
  Ireland: "Europe/Dublin",
  Israel: "Asia/Jerusalem",
  Italy: "Europe/Rome",

  Jamaica: "America/Jamaica",
  Japan: "Asia/Tokyo",
  Jordan: "Asia/Amman",

  Kazakhstan: "Asia/Almaty",
  Kenya: "Africa/Nairobi",
  Kuwait: "Asia/Kuwait",
  Kyrgyzstan: "Asia/Bishkek",

  Laos: "Asia/Vientiane",
  Latvia: "Europe/Riga",
  Lebanon: "Asia/Beirut",
  Liberia: "Africa/Monrovia",
  Libya: "Africa/Tripoli",
  Lithuania: "Europe/Vilnius",
  Luxembourg: "Europe/Luxembourg",

  Madagascar: "Indian/Antananarivo",
  Malawi: "Africa/Blantyre",
  Malaysia: "Asia/Kuala_Lumpur",
  Maldives: "Indian/Maldives",
  Mali: "Africa/Bamako",
  Malta: "Europe/Malta",
  Mexico: "America/Mexico_City",
  Moldova: "Europe/Chisinau",
  Monaco: "Europe/Monaco",
  Mongolia: "Asia/Ulaanbaatar",
  Montenegro: "Europe/Podgorica",
  Morocco: "Africa/Casablanca",
  Mozambique: "Africa/Maputo",
  Myanmar: "Asia/Yangon",

  Namibia: "Africa/Windhoek",
  Nepal: "Asia/Kathmandu",
  Netherlands: "Europe/Amsterdam",
  "New Zealand": "Pacific/Auckland",
  Nicaragua: "America/Managua",
  Niger: "Africa/Niamey",
  Nigeria: "Africa/Lagos",
  "North Korea": "Asia/Pyongyang",
  "Northern Ireland": "Europe/London",
  Norway: "Europe/Oslo",

  Oman: "Asia/Muscat",

  Pakistan: "Asia/Karachi",
  Palestine: "Asia/Gaza",
  Panama: "America/Panama",
  Paraguay: "America/Asuncion",
  Peru: "America/Lima",
  Philippines: "Asia/Manila",
  Poland: "Europe/Warsaw",
  Portugal: "Europe/Lisbon",

  Qatar: "Asia/Qatar",

  Romania: "Europe/Bucharest",
  Russia: "Europe/Moscow",
  Rwanda: "Africa/Kigali",

  SaudiArabia: "Asia/Riyadh",
  Scotland: "Europe/London",
  Senegal: "Africa/Dakar",
  Serbia: "Europe/Belgrade",
  Singapore: "Asia/Singapore",
  Slovakia: "Europe/Bratislava",
  Slovenia: "Europe/Ljubljana",
  Somalia: "Africa/Mogadishu",
  "South Africa": "Africa/Johannesburg",
  "South Korea": "Asia/Seoul",
  Spain: "Europe/Madrid",
  "Sri Lanka": "Asia/Colombo",
  Sudan: "Africa/Khartoum",
  Suriname: "America/Paramaribo",
  Sweden: "Europe/Stockholm",
  Switzerland: "Europe/Zurich",
  Syria: "Asia/Damascus",

  Taiwan: "Asia/Taipei",
  Tajikistan: "Asia/Dushanbe",
  Tanzania: "Africa/Dar_es_Salaam",
  Thailand: "Asia/Bangkok",
  Togo: "Africa/Lome",
  Tunisia: "Africa/Tunis",
  Turkey: "Europe/Istanbul",
  Turkmenistan: "Asia/Ashgabat",

  Uganda: "Africa/Kampala",
  Ukraine: "Europe/Kyiv",
  UAE: "Asia/Dubai",
  UK: "Europe/London",
  USA: "America/New_York",
  Uruguay: "America/Montevideo",
  Uzbekistan: "Asia/Tashkent",

  Venezuela: "America/Caracas",
  Vietnam: "Asia/Ho_Chi_Minh",

  Wales: "Europe/London",

  Yemen: "Asia/Aden",

  Zambia: "Africa/Lusaka",
  Zimbabwe: "Africa/Harare",
};

// ==========================================
// CONVERT MATCH TIME TO USER LOCAL TIME
// ==========================================
export const getLocalMatchTime = ({ country, matchDate, matchTime }) => {
  try {
    const matchTimezone = COUNTRY_TIMEZONES[country];

    if (!matchTimezone) {
      return { success: false, message: "Timezone not found" };
    }

    // 1. Create a formatter to "fake" a UTC conversion using the match's timezone
    // We parse the match date/time as if it were UTC, then adjust by the offset
    const matchString = `${matchDate}T${matchTime}:00`;

    // Actually, the most precise "Vanilla" way to handle "Match Time -> User Local":
    const matchTimeInUTC = new Date(new Date(matchString).toLocaleString('en-US', { timeZone: matchTimezone }));
    const diff = new Date(matchString) - matchTimeInUTC;
    const finalDate = new Date(new Date(matchString).getTime() + diff);

    // Extract components for manual formatting
   const day = String(finalDate.getDate()).padStart(2, '0');
    const month = String(finalDate.getMonth() + 1).padStart(2, '0');
    const year = finalDate.getFullYear();

    // Format hours and minutes to always have 2 digits (e.g., 05 instead of 5)
    const hours = String(finalDate.getHours()).padStart(2, '0');
    const minutes = String(finalDate.getMinutes()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hours}:${minutes}`;    

    return {
      success: true,
      matchTimezone,
      localDateTime: `${formattedDate} ${formattedTime}`,
      localDate: formattedDate,
      localTime: formattedTime,
    };

  } catch (error) {
    return { success: false, message: error.message };
  }
};